import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=27e004e1&scoped=true&"
import script from "./InfoIcon.vue?vue&type=script&lang=js&"
export * from "./InfoIcon.vue?vue&type=script&lang=js&"
import style0 from "./info-icon.scss?vue&type=style&index=0&id=27e004e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e004e1",
  null
  
)

export default component.exports